<script setup lang="ts">
withDefaults(defineProps<{
  variant?: 'alert' | 'live' | 'new' | 'soon'
}>(), {
  variant: 'live',
})
</script>

<template>
  <span
    class="inline-block font-display uppercase text-[10px] tracking-[0.14em] px-2 py-1 rounded-pill border border-brand-ink leading-none whitespace-nowrap"
    :class="{
      'bg-brand-yellow text-brand-ink': variant === 'live' || variant === 'new',
      'bg-brand-chalk text-brand-ink': variant === 'soon',
      'bg-brand-red text-brand-chalk': variant === 'alert',
    }"
  >
    <slot/>
  </span>
</template>
